import { useSelector } from 'react-redux'

import { useIsSignupMotivationsEnabled } from 'hooks/useIsSignupMotivationsEnabled'
import { getSignupMotivations } from 'routes/Signup/signupSelectors'

export function useIsSignupMotivations() {
  const isSignupMotivationsExperimentEnabled = useIsSignupMotivationsEnabled()
  const signupMotivations = useSelector(getSignupMotivations)
  const hasSignupMotivations = signupMotivations.toArray().length > 0
  const isSignupMotivations = isSignupMotivationsExperimentEnabled && hasSignupMotivations

  return { isSignupMotivations }
}
